/**
 * Возвращает слово в необходимой форме, зависимой от значения `count`.
 *
 * @example
 * pluralize(1, 'день', 'дня', 'дней'); // день
 * pluralize(2, 'день', 'дня', 'дней'); // дня
 * pluralize(5, 'день', 'дня', 'дней'); // дней
 *
 * @param {number} count - Число.
 * @param {string} nominative - Слово в именительном падеже единственного числа
 * @param {string} genitive - Слово в родительном падеже единственного числа
 * @param {string} plural - Слово во множественном числе
 *
 * @returns {string}
 */
const pluralize = (count, nominative, genitive, plural) => {
    const normalizedNumber = count % 100;
    if (normalizedNumber >= 11 && normalizedNumber <= 19) {
        return plural;
    }
    const remainder = normalizedNumber % 10;
    switch (remainder) {
        case 1:
            return nominative;
        case 2:
        case 3:
        case 4:
            return genitive;
        default:
            return plural;
    }
};

export { pluralize };
